import { lazy } from 'react';
import { Outlet, Route } from 'react-router-dom';

const LazyEnergyAccounting = lazy(() => import('@/pages/energy-accounting'));

const EnergyAccountingRoutes = (
  <Route
    path="energy-accounting"
    element={<Outlet />}>
    <Route
      index
      element={<LazyEnergyAccounting />}
    />
  </Route>
);

export default EnergyAccountingRoutes;
